export const U_DRAGS_LEADERBOARD_CONTENT_PATH = 'research/infographics/u-drags-leaderboard';
